import { CaretUpDown } from "@phosphor-icons/react"
import { colorsV4 } from "@tokenterminal/ui/theme/themeV4/colorsContract.css"
import { forwardRef } from "react"
import { Button, type ButtonProps } from "../button/Button"
import { Icon } from "../icon"
import CaretUpDownDown from "./CaretUpDownDown"
import CaretUpDownUp from "./CaretUpDownUp"
import HeaderWithSubtitle from "./HeaderWithSubtitle"

type SortableHeaderProps = Omit<ButtonProps, "children" | "title"> & {
  alignment?: "left" | "right"
  isActiveSort: boolean
  sortDirection: "asc" | "desc" | null
  subtitle?: React.ReactNode
  title: React.ReactNode
}

const SortableHeader = forwardRef<HTMLButtonElement, SortableHeaderProps>(
  (
    {
      alignment = "left",
      isActiveSort,
      onPress,
      sortDirection,
      subtitle,
      title,
      ...props
    },
    ref
  ) => {
    let sortIcon
    if (!isActiveSort) {
      sortIcon = (
        <Icon
          as={CaretUpDown}
          weight="fill"
          style={{ opacity: 0.25, width: "16px", height: "16px" }}
        />
      )
    } else if (sortDirection === "asc") {
      sortIcon = (
        <Icon
          as={CaretUpDownUp}
          style={{ color: colorsV4.fg.default, width: "16px", height: "16px" }}
        />
      )
    } else {
      sortIcon = (
        <Icon
          as={CaretUpDownDown}
          style={{ color: colorsV4.fg.default, width: "16px", height: "16px" }}
        />
      )
    }

    return (
      <Button
        ref={ref}
        className="tt-sortable-header-button"
        variant="ghost"
        size="small"
        onPress={onPress}
        {...props}
      >
        {alignment === "right" && sortIcon}
        <HeaderWithSubtitle
          title={title}
          subtitle={subtitle}
          alignment={alignment}
        />
        {alignment === "left" && sortIcon}
      </Button>
    )
  }
)
SortableHeader.displayName = "SortableHeader"

export default SortableHeader
